/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import { DtpContentContainer, DtpNoContent } from 'dtp-react-components';
import {
  doPost,
  doGet,
  doPostDocumentoComUrlDinamica,
  trataMensagensErro,
  trataMensagemSucesso,
  buscaDestinatarios,
  // solicitarHabilitarQualificacao,
} from '../../utils/requests';
import {
  Table,
  Button,
  Modal,
} from '../../components/index';
import * as listUtils from '../../utils/listsSelect';
import FiltroControlePagamentos from './templates/FiltroControlePagamentos';
import { ehPapelObservadorPagamento, manterApenasFiltro, formatarCnpj } from '../../utils/helpers';
import CalculadoraPagamento from './templates/CalculadoraPagamento';
import RelatorioControlePagamentos from './templates/RelatorioControlePagamentos';

class ControlePagamentos extends Component {
  constructor(props) {
    super(props);
    this.state = {
      acao: null,
      listaRegistrosFiltrada: null,
      listaRegistrosIndexada: [],
      listaRegistrosExportacao: [],
      registroVindoDoRequest: null,
      showNoContent: false,
      rowSelecionada: null,
      listaRegistrosIndexadaAtualizada: false,
      estadoTabela: {
        quantidadeTotalResultados: 0,
        resultadosPorPagina: 10,
        paginaAtual: 1,
      },
      filtrosConsulta: {},
      showCalculadoraModal: false,
      showRejeicaoRGPSModal: false,
      competencia: null,
      papelUsuarioLogado: null,
      titulo: '',
      showConfirmacaoGerarGRUModal: false,
    };
  }

  componentDidMount() {
    // solicitarHabilitarQualificacao();
    manterApenasFiltro('filtroControlePagamento');
    if (this.props.destinatarios.length === 0) {
      buscaDestinatarios(this.tratarErro);
    }
    this.definePapelFiltro();
    if (sessionStorage.getItem('tipoControle')) {
      if (sessionStorage.getItem('tipoControle') !== this.props.match.params.tipoControle ||
      this.props.history.action !== 'POP') {
        this.limpaListaTabela();
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.match.params.tipoControle !== prevProps.match.params.tipoControle) {
      this.limpaListaTabela();
    }
  }

  limpaListaTabela = () => {
    const estadoTabela = {
      quantidadeTotalResultados: 0,
      resultadosPorPagina: 10,
      paginaAtual: 1,
    };
    this.setState({
      listaRegistrosIndexada: [],
      estadoTabela,
      titulo: '',
    });
  }

  preparaNovaConsulta = () => {
    const estadoTabela = {
      quantidadeTotalResultados: 0,
      resultadosPorPagina: 10,
      paginaAtual: 1,
    };
    this.setState({
      listaRequerimentosFiltrada: null,
      estadoTabela,
    }, this.realizaConsulta());
  }

  realizaConsulta = (filtrosPesquisa) => {
    let filtros = {};
    if (filtrosPesquisa) {
      filtros = this.montaFiltros(filtrosPesquisa);
    }
    this.setState({ filtrosConsulta: filtros }, this.executaConsulta);
  }

  realizaConsultaPorRota = (visaoRota) => {
    let filtros = {};
    filtros = this.montaFiltrosRota(visaoRota);
    this.setState({ filtrosConsulta: filtros }, this.executaConsulta);
  }

  executaConsulta = () => {
    if (Object.entries(this.state.filtrosConsulta).length !== 0) {
      const { resultadosPorPagina } = { ...this.state.estadoTabela };
      const primeiroItem = (this.state.estadoTabela.paginaAtual - 1) * resultadosPorPagina;
      doGet(
        'controle-pagamentos',
        this.tratarSucesso,
        this.tratarErro,
        {
          ...this.state.filtrosConsulta,
          'start-position': primeiroItem,
          'max-results': resultadosPorPagina,
        },
      );
    } else {
      this.setState({ listaRegistrosIndexada: [], listaRegistrosIndexadaAtualizada: true });
    }
  }

  definePapelFiltro = () => {
    let retorno = '';
    const isAnalistaDcomp = this.props.auth.checkPermission(['gerenciar-negocio-dcomp']);
    const isRpps = this.props.auth.checkPermission(['requerer-compensacao-rpps', 'analisar-compensacao-rpps', 'consultar-compensacao-rpps']);
    const isAnalistaSprev = this.props.auth.checkPermission(['analisar-negocio-sprev']);
    const isAnalistaDtp = this.props.auth.checkPermission(['analisar-negocio-dtpv']);

    if (isAnalistaDcomp) {
      retorno = 'analista-rgps';
    }
    if (isRpps) {
      retorno = 'analista-rpps';
    }
    if (isAnalistaSprev) {
      retorno = 'analista-sprev';
    }
    if (isAnalistaDtp) {
      retorno = 'analista-dtp';
    }

    this.setState({
      papelUsuarioLogado: retorno,
    });
  }

  montaFiltros = (atributosPesquisa) => {
    let atributos = [];

    if (atributosPesquisa.participanteObservador) {
      atributos = { ...atributos, participanteObservador: atributosPesquisa.participanteObservador };
    }

    if (atributosPesquisa.competencia) {
      atributos = { ...atributos, competencia: atributosPesquisa.competencia };
    }
    if (atributosPesquisa.visaoControlePagamento) {
      atributos = {
        ...atributos,
        visaoControlePagamento: atributosPesquisa.visaoControlePagamento,
      };
    }
    if (atributosPesquisa.estadoPagamento) {
      atributos = { ...atributos, estadoPagamento: atributosPesquisa.estadoPagamento };
    }
    if (atributosPesquisa.tipoEntidade) {
      const tipoEntidadeString = atributosPesquisa.tipoEntidade;
      if (atributosPesquisa.tipoEntidade === '01000') {
        atributos = { ...atributos, idParticipante: '01000' };
      }
      if (tipoEntidadeString.toString() === '98222') {
        atributos = { ...atributos, idParticipante: '98222' };
      }
      if (tipoEntidadeString.toString() === '98026') {
        atributos = { ...atributos, idParticipante: '98026' };
      }
    }
    if (atributosPesquisa['destinatario-rpps']) {
      atributos = { ...atributos, idParticipante: atributosPesquisa['destinatario-rpps'] };
    }

    atributos = { ...atributos, tipoControle: this.props.match.params.tipoControle };

    let desconsiderar = 0;
    if (atributosPesquisa.desconsiderarFluxosExtraordinarios) {
      // checkbox marcado
      desconsiderar = 1;
    }
    atributos = { ...atributos, desconsiderarFluxosExtraordinarios: desconsiderar };

    const { resultadosPorPagina } = { ...this.state.estadoTabela };
    if (atributosPesquisa.cliqueiNoBotao === 1) {
      this.state.estadoTabela.paginaAtual = 1;
    }
    const primeiroItem = (this.state.estadoTabela.paginaAtual - 1) * resultadosPorPagina;
    atributos = { ...atributos, 'max-results': resultadosPorPagina };
    atributos = { ...atributos, 'start-position': primeiroItem };

    return atributos;
  }

  montaFiltrosRota = (visaoRota) => {
    let atributos = [];

    atributos = {
      ...atributos,
      tipoControle: this.props.match.params.tipoControle,
      visaoControlePagamento: visaoRota,
    };

    const { resultadosPorPagina } = { ...this.state.estadoTabela };

    const primeiroItem = (this.state.estadoTabela.paginaAtual - 1) * resultadosPorPagina;
    atributos = { ...atributos, 'max-results': resultadosPorPagina };
    atributos = { ...atributos, 'start-position': primeiroItem };

    return atributos;
  }

  trataSucessoResponseEnvio = () => {
    this.setState({
      chaveConfirmacao: null,
      alertas: [],
      showModalAlerta: !this.state.showModalAlerta,
    }, this.trataSucesso);
  }

  trataErrosResponse = (error) => {
    if (error && error.data) {
      trataMensagensErro(['Houve um erro na tentativa de se comunicar com o serviço. Por favor, tente novamente mais tarde.']);
    }
  }

  tratarSucessoListaExportacao = (response) => {
    if (response.data === '') {
      this.setState({
        listaRegistrosExportacao: [],
      });
    } else {
      this.setState({
        listaRegistrosExportacao: response.data,
      });
    }
  };

  recuperarListaExportacaoCSV = () => {
    if (Object.entries(this.state.filtrosConsulta).length !== 0) {
      doGet(
        'controle-pagamentos/exportacao-csv',
        this.tratarSucessoListaExportacao,
        this.tratarErro,
        {
          ...this.state.filtrosConsulta,
        },
      );
    } else {
      this.setState({ listaRegistrosExportacao: [] });
    }
  }

  tratarSucesso = (response) => {
    let quantidadeTotalResultados = 0;
    if (response.headers['content-range']) {
      const { headers } = { ...response };
      // eslint-disable-next-line
      quantidadeTotalResultados = headers['content-range'].split('/')[1];
    }
    const { estadoTabela } = { ...this.state };
    estadoTabela.quantidadeTotalResultados = quantidadeTotalResultados;
    if (response.data === '') {
      this.setState({
        showNoContent: false,
        listaRegistrosIndexada: [],
        listaRegistrosIndexadaAtualizada: true,
        estadoTabela,
      });
    } else {
      this.setState({
        showNoContent: false,
        listaRegistrosIndexada: this.props.match.params.tipoControle === 'controle-pagamentos' ||
        this.props.match.params.tipoControle === 'pendencias' ? response.data : response.data.pagamentos,
        listaRegistrosIndexadaAtualizada: true,
        estadoTabela,
      }, this.montaParametrosTitulo(response.data.totalizador, response.data.entidadeFiltro));
    }
  };

  /**
   * Trata filtros na lista que veio do servidor (Componente FiltroPagamentos)
   */
  tratarFiltroNaLista = (listaRegistrosFiltrada) => {
    this.setState({ listaRegistrosFiltrada, listaRegistrosIndexadaAtualizada: false });
  }

  tratarErro = (error) => {
    if (error) {
      const { data } = { ...error };
      let lista;
      if (error.status) {
        if (error.data.erros) {
          if (error.data.erros[0]) {
            const codigoErro = error.data.erros[0].codigo;
            if (codigoErro === 1587) {
              lista = [];
            }
          }
        }
        this.setState({
          noContentPrimaryMessage: `${data.mensagem}`,
          noContentSecondaryMessage: `${data.descricao}`,
          listaRegistrosIndexada: lista,
        });
      } else {
        this.setState({
          noContentPrimaryMessage: 'Ocorreu uma falha de comunicação com o serviço de compensação previdenciária.',
          noContentSecondaryMessage: 'Tente novamente mais tarde.',
        });
      }
    }
  }

  handleChange = (e, name) => {
    this.setState({
      ...this.state,
      [name]: e,
    });
  }

  handleCloseModal = (modalStateName) => {
    this.setState({ [modalStateName]: false });
  }

  addCompetenciaLabel = (p, row) => {
    let objCompetencia = '';
    if (row && (row.mes !== '0' && row.ano !== '0')) {
      objCompetencia = `${row.mes}/${row.ano}`;
      if (objCompetencia.length !== 7) {
        objCompetencia = `0${objCompetencia}`;
      }
    }
    return objCompetencia;
  };

  addTipoEstadoPagamentoLabel = (tipo) => {
    const listaEstados = listUtils.estadosPagamento;
    const estado = listUtils.getObject(listaEstados, tipo).label;
    let estadoCss = '';
    estadoCss = estado;

    switch (tipo) {
      case 1:
        estadoCss = 'Aberto';
        break;
      case 2:
        estadoCss = 'EmProcessamento';
        break;
      case 3:
        estadoCss = 'Contestado';
        break;
      case 4:
        estadoCss = 'AguardandoAnaliseDefesa';
        break;
      case 5:
        estadoCss = 'Pago';
        break;
      case 6:
        estadoCss = 'Rejeitado';
        break;
      case 7:
        estadoCss = 'NaoPago';
        break;
      case 8:
        estadoCss = 'NaoMonitorado';
        break;
      case 9:
        estadoCss = 'EmAnaliseDefesaRegularidadePagamento';
        break;
      case 10:
        estadoCss = 'EmAnaliseDefesaGru';
        break;
      case 11:
        estadoCss = 'EmAnaliseDefesaExtraordinaria';
        break;
      case 12:
        estadoCss = 'ContestacaoExtraordinaria';
        break;
      default: estadoCss = '';
    }

    return (
      <React.Fragment>
        {(<div className={`estado${estadoCss}`}>{estado}</div>)}
      </React.Fragment>
    );
  };

  formatarValorLabel = (valorCompensacao) => {
    let valorFormatado = '';
    if (valorCompensacao) {
      valorFormatado = valorCompensacao.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 3 });
    }
    return valorFormatado;
  };

  formatarCnpj = (cnpj) => {
    if (!cnpj) return '';
    return cnpj.replace(/^(.{2})(.{3})(.{3})(.{4})(.{2})$/, '$1.$2.$3/$4-$5');
  };

  gerarGru = (row) => {
    doPostDocumentoComUrlDinamica(`/controle-pagamentos/${row.idControlePagamento}/grus`);
  }

  gerarGruViaModalConfirmacao = (row) => {
    doPostDocumentoComUrlDinamica(`/controle-pagamentos/${row.idControlePagamento}/grus`);
    this.handleFechamentoModalAlertaGeracaoGRU();
  }

  rejeitarPagamentoRGPS = () => {
    const urlRejeitarRGPS = `mensagem-pagamento-participante/rgps-rejeitado/${this.state.rowSelecionada.idControlePagamento}`;

    doPost(
      urlRejeitarRGPS,
      null,
      () => {
        trataMensagemSucesso(['pagamento rejeitado']);
        this.handleCloseModal('showRejeicaoRGPSModal');
        this.realizaConsulta(this.state.filtrosConsulta);
      },
    //  () => { trataMensagensErro(['erro']); },
    );
  }

  showDetalhe = (row) => {
    this.props.history.push(`/controledepagamentos/detalhe/${row.idControlePagamento}/${this.props.match.params.tipoControle}`);
  }

  montaAcoes = (row) => {
    // const analistaRGPSLogado = User.logged().isRGPS();
    const acaoDetalhar = true;
    const acaoCalculadora = (!ehPapelObservadorPagamento(this.state.papelUsuarioLogado)) && (row.exibirBotaocalculadora);
    const acaoGRU = (!ehPapelObservadorPagamento(this.state.papelUsuarioLogado)) && (row.exibirBotaoAcaoGru);
    const acaoRegeitarRGPS = (!ehPapelObservadorPagamento(this.state.papelUsuarioLogado)) &&
    (row.entidadePagadora === '01000' && row.estado === 8 && row.codigoParticipanteLogado === '01000');
    const exibirConfirmacaoGerarGRU = (row.estado === 9 || row.estado === 10);
    // const acaoDetalharGRU = true;
    const botaoAcaoGRU = acaoGRU ? (
      <Button
        hint="Ação GRU"
        icon="ico-print"
        id="acao-gru"
        mini
        // onClick={() => this.gerarGru(row)
        onClick={exibirConfirmacaoGerarGRU ? () => this.showConfirmacaoGerarGRUModal(row) : () => this.gerarGru(row)}
      />
    ) : '';
    const botaoCalculadora = acaoCalculadora ? (
      <Button
        hint="Calculadora"
        icon="ico-calc"
        id="calculadora"
        mini
        onClick={() => this.showCalculadoraModal(row)}
      />
    ) : '';
    const botaoRejeitarRGPS = acaoRegeitarRGPS ? (
      <Button
        hint="Informar rejeição de pagamento"
        icon="ico-doc-thumb-down"
        id="rejeitarRGPS"
        mini
        onClick={() => this.showRejeicaoRGPSModal(row)}
      />
    ) : '';
    const botaoDetalhar = acaoDetalhar ? (
      <Button
        hint="Detalhar"
        icon="ico-chat"
        id="detalhar"
        mini
        onClick={e => this.showDetalhe(row, e)}
      />
    ) : '';
    return (
      <React.Fragment>
        {botaoAcaoGRU}
        {botaoCalculadora}
        {botaoRejeitarRGPS}
        {botaoDetalhar}
      </React.Fragment>
    );
  }

  createActionColumn = (cell, row) => (
    this.montaAcoes(row)
  )

  montaColunasEspecificasTipoEntidade = () => {
    const { filtrosConsulta } = { ...this.state };
    if (filtrosConsulta && filtrosConsulta.visaoControlePagamento === 1) {
      return [{
        id: 'nomeEntidadePagadora',
        label: 'Participante',
      }];
    }
    return [{
      id: 'nomeEntidadeRecebedora',
      label: 'Participante',
    }];
  };

  montaColunasEspecificasRPPS = () => {
    if (this.state.papelUsuarioLogado === 'analista-rgps') {
      return [{
        id: 'dataCreditoPagamento',
        label: 'Data de Crédito do Pagamento',
      }];
    }
    return [{
      id: 'dataHomologacaoTribunalContas',
      label: 'Data de Homologação no Tribunal de Contas',
    }];
  };

  montaColunas = () => {
    const { filtrosConsulta } = { ...this.state };
    const { tipoControle } = { ...this.props.match.params };
    const colunas = this.montaColunasPeloTipoControle(this.props.match.params.tipoControle);
    const consultaPagamentoTableHeader = colunas.slice();
    let colunasEspecificas = [];

    if (tipoControle === 'controle-pagamentos' || tipoControle === 'pendencias') {
      if (filtrosConsulta.visaoControlePagamento === 1) { // 'Valores a receber'
        colunasEspecificas.push({
          id: 'cnpjPagador',
          label: 'CNPJ',
          dataFormat: formatarCnpj,
        });
      } else {
        colunasEspecificas.push({
          id: 'cnpj',
          label: 'CNPJ',
          dataFormat: formatarCnpj,
        });
      }
      colunasEspecificas = colunasEspecificas.concat(this.montaColunasEspecificasTipoEntidade());
    }

    if (tipoControle === 'controle-debitos-pendentes' &&
      (this.state.papelUsuarioLogado === 'analista-rgps' || filtrosConsulta.participanteObservador === '01000')
    ) {
      colunasEspecificas.push({
        id: 'cnpjPagador',
        label: 'CNPJ',
        dataFormat: formatarCnpj,
      });
    }

    if (colunasEspecificas) {
      colunasEspecificas = colunasEspecificas.concat(consultaPagamentoTableHeader);
      if (this.props.match.params.tipoControle === 'controle-debitos-pendentes' &&
        (this.state.papelUsuarioLogado === 'analista-rgps' || this.state.filtrosConsulta.participanteObservador === '01000')) {
        colunasEspecificas = colunasEspecificas.concat(this.colunasDebitosPendentes);
      }
    }
    colunasEspecificas.push({
      id: 'acoes',
      label: 'Ações',
      dataFormat: this.createActionColumn,
    });

    return colunasEspecificas;
  }

  montaColunasPeloTipoControle = (tipoControle) => {
    let colunasTabela = '';
    switch (tipoControle) {
      case 'controle-pagamentos':
        colunasTabela = this.colunasDefault;
        break;
      case 'controle-debitos-pendentes':
        colunasTabela = this.montaColunasEspecificasDebitosPendentes();
        break;
      case 'pendencias':
        colunasTabela = this.colunasEspecificasPendencias;
        break;
      default: colunasTabela = '';
    }
    return colunasTabela;
  }

  colunasDefault = [
    {
      id: 'dataPrazo',
      label: 'Prazo Resposta',
    }, {
      id: 'valorCompensacao',
      label: 'Valor',
      dataFormat: this.formatarValorLabel,
    }, {
      id: 'estado',
      label: 'Estado',
      dataFormat: this.addTipoEstadoPagamentoLabel,
    }];

  montaColunasEspecificasDebitosPendentes = () => {
    if (this.state.papelUsuarioLogado === 'analista-rgps' || this.state.filtrosConsulta.participanteObservador === '01000') {
      return [{
        id: 'nomeEntidadePagadora',
        label: 'Participante',
      }];
    }
    return this.colunasDebitosPendentes;
  };

  colunasDebitosPendentes = [
    {
      id: 'competencia',
      label: 'Competência',
      dataFormat: this.addCompetenciaLabel,
    },
    {
      id: 'valorCompensacao',
      label: 'Valor',
      dataFormat: this.formatarValorLabel,
    },
    {
      id: 'dataVencimento',
      label: 'Data de Vencimento',
    },
    {
      id: 'estado',
      label: 'Estado',
      dataFormat: this.addTipoEstadoPagamentoLabel,
    }]

  colunasEspecificasPendencias = [
    {
      id: 'competencia',
      label: 'Competência',
      dataFormat: this.addCompetenciaLabel,
    },
    {
      id: 'dataPrazo',
      label: 'Prazo Resposta',
    },
    {
      id: 'valorCompensacao',
      label: 'Valor',
      dataFormat: this.formatarValorLabel,
    },
    {
      id: 'dataVencimento',
      label: 'Data de Vencimento',
    },
    {
      id: 'estado',
      label: 'Estado',
      dataFormat: this.addTipoEstadoPagamentoLabel,
    }];

  defineListaParaTabela = () => {
    if (this.state.listaRegistrosFiltrada !== null) {
      return this.state.listaRegistrosFiltrada;
    }
    return this.state.listaRegistrosIndexada;
  }

  alterarPagina = (pagina, page) => {
    const { estadoTabela } = { ...this.state };
    if (pagina === 0) {
      estadoTabela.paginaAtual = 1;
    } else {
      estadoTabela.paginaAtual = pagina;
    }

    if (page) {
      estadoTabela.resultadosPorPagina = page;
    }

    this.setState({
      estadoTabela,
      ...this.state,
    }, this.realizaConsulta());
  }

  alterarResultadosPorPagina = (resultadosPorPagina) => {
    const { estadoTabela } = { ...this.state };
    estadoTabela.resultadosPorPagina = resultadosPorPagina;
    this.setState({
      estadoTabela,
      ...this.state,
    }, this.realizaConsulta());
  }

  trataSucesso = () => {
    this.realizaConsulta(this.state.filtrosConsulta);
    trataMensagemSucesso(['Contestação de pagamento criada.']);
    this.handleModalContestacao('showContestacaoModal');
  }

  trataSucessoResponseEnvio = () => {
    this.setState({
      chaveConfirmacao: null,
      alertas: [],
    }, this.trataSucesso);
  }

  showCalculadoraModal = (row) => {
    this.setState({
      showCalculadoraModal: !this.state.showCalculadoraModal,
      rowSelecionada: row,
    });
  };

  showRejeicaoRGPSModal = (row) => {
    this.setState({
      showRejeicaoRGPSModal: !this.state.showCalculadoraModal,
      rowSelecionada: row,
    });
  };

  showConfirmacaoGerarGRUModal = (row) => {
    this.setState({
      showConfirmacaoGerarGRUModal: !this.state.showConfirmacaoGerarGRUModal,
      rowSelecionada: row,
    });
  };

  exibirComplementoTitulo = () => {
    let retorno = '';
    const { complementoTitulo } = { ...this.props };
    let paramComplementoTitulo = '';
    if (complementoTitulo !== null) {
      paramComplementoTitulo = JSON.parse(complementoTitulo);
      if (paramComplementoTitulo.complementoTitulo && paramComplementoTitulo.complementoTitulo !== '') {
        retorno = ` - ${paramComplementoTitulo.complementoTitulo}`;
      }
    }
    // requestApagaComplementoTitulo();
    return retorno;
  };

  montaParametroVisaoDePendencias = (visaoControlePagamento, participanteObservador) => {
    let retorno;
    if (this.state.papelUsuarioLogado === 'analista-rgps' || participanteObservador === '01000') {
      retorno = '- valores a receber';
    } else if (visaoControlePagamento === 1) {
      retorno = '- valores a receber';
    } else {
      retorno = '- valores a pagar';
    }
    return retorno;
  }

  montaParametrosTitulo = (totalizador, entidadeFiltro) => {
    const { tipoControle } = { ...this.props.match.params };
    const { participanteObservador, visaoControlePagamento } = { ...this.state.filtrosConsulta };
    let mensagem = '';
    const dataAtual = `${moment(new Date()).format('DD/MM/YYYY HH:mm:ss')}`;
    switch (tipoControle) {
      case 'controle-debitos-pendentes': {
        let primeiroParametro = '';
        if (this.state.papelUsuarioLogado === 'analista-rgps' || participanteObservador === '01000') {
          const nomeParticipante = entidadeFiltro !== undefined ? entidadeFiltro : 'TODOS';
          primeiroParametro = `- Valores a Receber do Participante - ${nomeParticipante}`;
        } else {
          primeiroParametro = '- Valores a Pagar ao RGPS';
        }
        mensagem = `${primeiroParametro} - R$ ${totalizador.toLocaleString('pt-BR')}  - Data: ${dataAtual}`;
        break;
      }
      case 'pendencias': {
        const primeitoParametro = this.montaParametroVisaoDePendencias(visaoControlePagamento, participanteObservador);
        mensagem = `${primeitoParametro} - Data: ${dataAtual}`;
        break;
      }
      default: mensagem = '';
    }
    this.setState({
      titulo: mensagem,
    });
  }

  montaLegendaTitulo = (tipoControle) => {
    let retornoLegenda;
    switch (tipoControle) {
      case 'controle-pagamentos':
        retornoLegenda = `Controle de Pagamentos ${this.exibirComplementoTitulo()}`;
        break;
      case 'controle-debitos-pendentes':
        retornoLegenda = `Controle de Débitos Carregados RGPS ${this.state.titulo}`;
        break;
      case 'pendencias':
        retornoLegenda = `Pendências de Controle de Pagamento ${this.state.titulo}`;
        break;
      default: retornoLegenda = '';
    }
    return retornoLegenda;
  }

  handleFechamentoModalAlertaGeracaoGRU = () => {
    this.setState({
      chaveConfirmacao: null,
      alertas: [],
      showConfirmacaoGerarGRUModal: !this.state.showConfirmacaoGerarGRUModal,
    });
  }

  renderModalCalculadora = () => {
    let infoPagamento = null;
    if (this.state.rowSelecionada) {
      infoPagamento = {
        idControlePagamento: null,
        nomeEntidadePagadora: '',
        nomeEntidadeRecebedora: '',
        codigoBanco: '',
        nomeBanco: '',
        numeroAgencia: '',
        dvAgencia: '',
        numeroContaCorrente: '',
        dvContaCorrente: '',
        cnpj: '',
        mes: '',
        ano: '',
        valorCompensacao: this.state.rowSelecionada.valorCompensacao,
        dataVencimento: this.state.rowSelecionada.dataVencimento,
        dataPagamentoAtraso: '',
        valorMulta: '',
        valorJuros: '',
        mensagens: [],
        estado: null,
        codigoParticipanteLogado: null,
        indicadorAtraso: null,
      };
    }

    return (infoPagamento !== null ?
      <CalculadoraPagamento
        valorParcial={null}
        infoPagamento={infoPagamento}
        mostrarCamposAdicionais
      /> : <div>.</div>
    );
  };

  renderFooterModalConfirmarRejeicaoRGPS = () => (
    <React.Fragment>
      <div style={{ textAlign: 'right' }}>
        <Button
          className="dtp-primary right"
          title="Confirmar Rejeição"
          id="confirmarRejeicao"
          onClick={() => this.rejeitarPagamentoRGPS()}
        />
        <Button
          title="Cancelar"
          id="cancelarRejeicao"
          onClick={() => this.handleCloseModal('showRejeicaoRGPSModal')}
        />
      </div>
    </React.Fragment>
  )

  renderFooterModalConfirmarGerarGRU = () => (
    <React.Fragment>
      <div style={{ textAlign: 'right' }}>
        <Button
          className="dtp-primary right"
          title="Confirmar geração GRU"
          id="confirmarGeracaoGRU"
          onClick={() => this.gerarGruViaModalConfirmacao(this.state.rowSelecionada)}
        />
        <Button
          title="Cancelar"
          id="cancelarGeracaoGRU"
          onClick={() => this.handleCloseModal('showConfirmacaoGerarGRUModal')}
        />
      </div>
    </React.Fragment>
  )

  render() {
    const options = {
      noDataText: 'Nenhum pagamento a ser exibido',
      hideSizePerPage: false,
      onPageChange: this.alterarPagina,
      page: this.state.estadoTabela.paginaAtual,
      sizePerPage: this.state.estadoTabela.resultadosPorPagina,
      sizePerPageList: listUtils.linhasPorPagina,
    };
    const fetchInfo = {
      dataTotalSize: this.state.estadoTabela.quantidadeTotalResultados,
    };
    const consultaPagamentoTableHeader = this.montaColunas();
    const jssConfirmacaoRejeicaoRGPS = {
      fontSize: '20px',
      marginBottom: '30px',
      textAlign: 'center',
      fontFamily: 'Open Sans',
    };

    return (
      this.state.showNoContent ? (
        <DtpNoContent
          primarylabel={this.state.noContentPrimaryMessage}
          secondarylabel={this.state.noContentSecondaryMessage}
          show={this.state.showNoContent}
        />
      ) : (
        <DtpContentContainer>
          <FiltroControlePagamentos
            handleSearchFilter={this.realizaConsulta}
            handleChangeList={this.tratarFiltroNaLista}
            list={this.state.listaRegistrosIndexada}
            listaRegistrosIndexadaAtualizada={this.state.listaRegistrosIndexadaAtualizada}
            destinatarios={this.props.destinatarios}
            competencia={this.state.competencia}
            tipoControle={this.props.match.params.tipoControle}
            papelUsuarioLogado={this.state.papelUsuarioLogado}
            visaoRota={this.props.match.params.visaoRota}
            handleSearchPorRota={this.realizaConsultaPorRota}
            history={this.props.history}
          />
          {((this.state.listaRegistrosIndexada) && (this.state.listaRegistrosIndexada.length > 0)) ?
            <RelatorioControlePagamentos
              filtrosConsulta={this.state.filtrosConsulta}
              tipoControle={this.props.match.params.tipoControle}
              papelUsuarioLogado={this.state.papelUsuarioLogado}
              tituloTabela={this.state.titulo}
            />
          : '' }
          <Table
            legend={this.montaLegendaTitulo(this.props.match.params.tipoControle)}
            bordered
            fetchInfo={fetchInfo}
            data={this.defineListaParaTabela()}
            options={options}
            listaTableHeader={consultaPagamentoTableHeader}
            pagination
            remote
          />
          <Modal
            {...this.props}
            conteudomodal={this.renderModalCalculadora()}
            conteudofooter={<br />}
            size="lg"
            showModal={this.state.showCalculadoraModal}
            title="Calculadora"
            onHide={() => { this.handleCloseModal('showCalculadoraModal'); }}
          />
          <Modal
            {...this.props}
            conteudomodal={<div style={jssConfirmacaoRejeicaoRGPS}>Confirma a rejeição do pagamento?</div>}
            conteudofooter={this.renderFooterModalConfirmarRejeicaoRGPS()}
            size="md"
            showModal={this.state.showRejeicaoRGPSModal}
            title="Rejeitar Pagamento"
            onHide={() => { this.handleCloseModal('showRejeicaoRGPSModal'); }}
          />
          <Modal
            {...this.props}
            conteudomodal={
              <div style={jssConfirmacaoRejeicaoRGPS}>Existe uma análise de defesa em andamento.
                Caso você gere uma nova GRU, essa análise será interrompida. Prosseguir com a geração da GRU?
              </div>
            }
            conteudofooter={this.renderFooterModalConfirmarGerarGRU()}
            size="md"
            showModal={this.state.showConfirmacaoGerarGRUModal}
            title="Confirmar geração de GRU"
            onHide={() => { this.handleCloseModal('showConfirmacaoGerarGRUModal'); }}
          />
        </DtpContentContainer>
      )
    );
  }
}

ControlePagamentos.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      acao: PropTypes.string,
      mes: PropTypes.string,
      ano: PropTypes.string,
      participanteUm: PropTypes.string,
      participanteDois: PropTypes.string,
      tipoControle: PropTypes.string,
      visaoRota: PropTypes.string,
    }),
  }),
  history: PropTypes.shape({
    push: PropTypes.func,
    action: PropTypes.string,
  }).isRequired,
  auth: PropTypes.shape({
    userData: PropTypes.object,
    checkPermission: PropTypes.func,
  }).isRequired,
  destinatarios: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.number,
    label: PropTypes.string,
  })),
  complementoTitulo: PropTypes.string,
  configuracoesFrontend: PropTypes.arrayOf(PropTypes.string),
};

ControlePagamentos.defaultProps = {
  match: null,
  destinatarios: [],
  complementoTitulo: '',
  configuracoesFrontend: null,
};

const mapStateToProps = state => ({
  destinatarios: state.base.destinatarios,
  complementoTitulo: state.base.complementoTitulo,
  configuracoesFrontend: state.base.configuracoesFrontend,
});

export default connect(mapStateToProps)(ControlePagamentos);




// WEBPACK FOOTER //
// ./src/pages/controle-pagamento/ControlePagamentos.jsx